'use strict';
import {EwSiteApp} from '../../app/ewsiteapp';


/** EUCOOKIE */

EwSiteApp.controller('EuCookieCtrl', ['$scope', '$http', '$attrs', '$log', function ($scope, $http, $attrs, $log) {
		$scope.data = {};
		$scope.state = 0;
		$scope.pop = false;
		$scope.showLine = true;
		$scope.message = '';
		$scope.loading = false;
		$scope.error = false;

		if ($scope.state == 1) {
			$scope.showLine = false;
		}
		$scope.hiddeLine = function () {
			$scope.showLine = false;
		};
		$scope.closePopup = function () {
			$scope.pop = false;
		};
		$scope.showPop = function () {
			$scope.pop = !$scope.pop;
		};

		$scope.storeAllChoises = function () {
			Object.keys($scope.data).forEach(function (key) {
				$scope.data[key] = true
			});
			$scope.storeChoises();
		};

		$scope.storeMandatoryCookies = function () {
			$scope.data.privacy_1 = true;
			$scope.data.privacy_2 = false;
			$scope.data.privacy_3 = false;
			$scope.data.privacy_4 = false;
			$scope.storeChoises();
		};

		$scope.storeChoises = function () {
			$scope.loading = true;

			$http({
				method: 'POST',
				url: unescape($attrs.storeUrl),
				data: $scope.data,
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				if (typeof (response.data.message) !== 'undefined' && response.data.message) {
					$scope.message = response.data.message;
					$scope.loading = false;
					$scope.closePopup();
					$scope.hiddeLine();
				} else {
					$scope.error = true;
					$scope.loading = false;
				}
				if (typeof (response.data.reload) !== 'undefined' && response.data.reload) {
					reloadPage();
				}
				if (typeof (response.data.collection) !== 'undefined') {
					loadCollection(response.data.collection);
				}
			}, function (response) {
				console.log(['Error', response]);
			});
		};

		function loadCollection(collection) {
			let ifr = document.createElement('iframe');
			ifr.style.display = 'none';
			document.body.appendChild(ifr);
			if (typeof (collection.head) !== 'undefined' && collection.head.length > 0) {
				for (let bl of collection.head) {
					ifr.contentDocument.head.innerHTML += bl;
				}
				for (let nod of ifr.contentDocument.head.childNodes) {
					if (nod.nodeType !== 1) {
						continue;
					}
					let ss = document.createElement(nod.tagName);
					for (let att of nod.attributes) {
						ss.setAttribute(att.nodeName, att.nodeValue);
					}
					ss.innerText = nod.innerText;
					document.head.appendChild(ss);
				}
			}
			document.body.removeChild(ifr);
		}

		function reloadPage() {
			location.reload();
		}
		$('.toggle_cookies_block').keydown(function (e) {
			if (e.keyCode === 13) { // Check if the pressed key is Enter (key code 13)
				// Trigger a click event on the element to simulate a click
				$(this).click();
			}
		});
	}]);